import { primevueConfig } from '@bo/primevue';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import type { App } from 'vue';

export const initPrimeVue = (app: App<Element>) => {
    app.use(PrimeVue, {
        ...primevueConfig,
        locale: {
            // 1 = Montag als erster Tag der Woche
            firstDayOfWeek: 1,

            // Deutsche Tages- und Monatsnamen
            dayNames: [
                'Sonntag',
                'Montag',
                'Dienstag',
                'Mittwoch',
                'Donnerstag',
                'Freitag',
                'Samstag',
            ],
            dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
            dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            monthNames: [
                'Januar',
                'Februar',
                'März',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember',
            ],
            monthNamesShort: [
                'Jan',
                'Feb',
                'Mär',
                'Apr',
                'Mai',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Okt',
                'Nov',
                'Dez',
            ],

            // Standard-Buttons im Kalender
            today: 'Heute',
            clear: 'Löschen',

            // Standard-Datumsformat (Tag.Monat.Jahr)
            dateFormat: 'dd.mm.yy',
        },
    });
    app.directive('tooltip', Tooltip);
};
